export const GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_ERROR = 'GET_CATEGORIES_ERROR';

export const ADD_CATEGORIES_REQUEST = 'ADD_CATEGORIES_REQUEST';
export const ADD_CATEGORIES_SUCCESS = 'ADD_CATEGORIES_SUCCESS';
export const ADD_CATEGORIES_ERROR = 'ADD_CATEGORIES_ERROR';

export const ADD_FORUMARTICLE_REQUEST = 'ADD_FORUMARTICLE_REQUEST';
export const ADD_FORUMARTICLE_SUCCESS = 'ADD_FORUMARTICLE_SUCCESS';
export const ADD_FORUMARTICLE_ERROR = 'ADD_FORUMARTICLE_ERROR';

export const GET_FORUMARTICLES_REQUEST = 'GET_FORUMARTICLES_REQUEST';
export const GET_FORUMARTICLES_SUCCESS = 'GET_FORUMARTICLES_SUCCESS';
export const GET_FORUMARTICLES_ERROR = 'GET_FORUMARTICLES_ERROR';

export const GET_FORUMARTICLE_REQUEST = 'GET_FORUMARTICLE_REQUEST';
export const GET_FORUMARTICLE_SUCCESS = 'GET_FORUMARTICLE_SUCCESS';
export const GET_FORUMARTICLE_ERROR = 'GET_FORUMARTICLE_ERROR';

export const ADD_COMMENT_REQUEST = 'ADD_COMMENT_REQUEST';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_ERROR = 'ADD_COMMENT_ERROR';

export const SEND_COACHING_REQUEST = 'SEND_COACHING_REQUEST';
export const SEND_COACHING_SUCCESS = 'SEND_COACHING_SUCCESS';
export const SEND_COACHING_ERROR = 'SEND_COACHING_ERROR';

export const GET_NEWS_REQUEST = 'GET_NEWS_REQUEST';
export const GET_NEWS_SUCCESS = 'GET_NEWS_SUCCESS';
export const GET_NEWS_ERROR = 'GET_NEWS_ERROR';

export const ADD_NEWS_REQUEST = 'ADD_NEWS_REQUEST';
export const ADD_NEWS_SUCCESS = 'ADD_NEWS_SUCCESS';
export const ADD_NEWS_ERROR = 'ADD_NEWS_ERROR';

export const GET_PRIORITY_NEWS_REQUEST = 'GET_PRIORITY_NEWS_REQUEST';
export const GET_PRIORITY_NEWS_SUCCESS = 'GET_PRIORITY_NEWS_SUCCESS';
export const GET_PRIORITY_NEWS_ERROR = 'GET_PRIORITY_NEWS_ERROR';
